import {
	IOtpSessionResponse,
	OtpDistributionChannel,
} from 'selfServicePortal/interfaces/i-api-sdd'
import axios from '../axios'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import appConfig from 'app.config'
import { logError } from 'shared'

export enum ContactInfoChangeType {
	Unknown,
	PhoneNumber,
	Email,
	Address,
}

export interface InitiateUserUpdateParams {
	newContactDetail?: string
	address?: {
		shortAddress: string
		city: string
		street: string
		houseNumber: string
		apartmentNumber: string
		postalCode: string
	}
	changeType: ContactInfoChangeType
	customerId?: string
	title?: string
	firstName?: string
	lastName?: string
	emailAddress?: string
	phoneNumber?: string
	distributionChannel: OtpDistributionChannel
	market: string | undefined
}

export interface CompleteUserUpdateParams {
	customerId: string | undefined
	sessionId: string | undefined
	otpCode: string
}

export async function initiateUserUpdate(params: InitiateUserUpdateParams) {
	const response = await axios
		.post<IOtpSessionResponse>(
			`${appConfig.customerDataBaseUrl}/api/user/update/initiate`,
			params,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
	return response
}

export const completeUserUpdateErrors: Record<string, string> = {
	'validation-failed': 'Validierung fehlgeschlagen',
	'data-not-found':
		'Login-Vorgang konnte nicht gefunden werden oder ist abgelaufen.',
	'address-change-not-allowed':
		'Ihre Adresse kann nur einmal innerhalb von 90 Tagen geändert werden. Sollten Sie die Änderung trotzdem vornehmen wollen, kontaktieren Sie uns bitte per E-Mail an service@tfbank.de.',
	'address-change-pending':
		'Ihre Kontaktinformationen können derzeit nicht geändert werden. Eine Änderung ist derzeit bereits in Bearbeitung.',
	'entity-already-exists':
		'Die Kontaktinformation wird bereits in einem anderen Konto verwendet.',
}

export function deriveUserUpdateError(error: string, isDeposit: boolean) {
	const isAT = appConfig.country === 'at'

	if (isAT && isDeposit && error === 'address-change-not-allowed') {
		return 'Ihre Adresse kann nur einmal innerhalb von X Tagen geändert werden.'
	}
	return completeUserUpdateErrors[error]
}

export async function completeUserUpdate(params: CompleteUserUpdateParams) {
	const response = await axios
		.post<IOtpSessionResponse>(
			`${appConfig.customerDataBaseUrl}/api/user/update/complete`,
			params,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
	return response
}

export async function rejectContactInfoChange(id: string) {
	const response = await axios
		.post<IOtpSessionResponse>(
			`${appConfig.customerDataBaseUrl}/api/user/rejectcontactinfochange/${id}`,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
	return response
}
